import { useFetcher } from "~/hooks/useFetcher";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

interface UserStats {
  enabled_users_count: number;
  current_month_active_user_count: number;
  includes_system_users: boolean;
}

const useUserStats = () => {
  return useFetcher<UserStats>(`${ACCESS_CONTROLLER_V1}/users/stats?include_system_users=false`);
};

export default useUserStats;
